import styles from "./filter-option-button.module.css";

export default function FilterOptionButton({
    option,
    isSelected,
    onSelect,
    children,
}: {
    option: string;
    isSelected: boolean;
    onSelect: (option: string) => void;
    children?: React.ReactNode;
}): JSX.Element {
    return (
        <button
            className={`${styles.filterOptionButton} ${
                isSelected ? styles.filterOptionButton_selected : ""
            }`}
            onClick={() => onSelect(option)}
            aria-checked={isSelected}
            role="switch"
        >
            {option}
            {children}
        </button>
    );
}
